/* ============================================================
   WORKSPACE v4 — PROTOTAIP DESIGN — composer, susunan B "dua lajur"
   ============================================================
   ⛔ PROTOTAIP UI/UX SAHAJA (arahan user 15 Okt 2026). Data contoh
      datang sebagai prop daripada [WorkspaceV4PilotView.jsx]; Generate
      tidak membuat apa-apa. Tiada Firebase, tiada callable.

   Susunan B (dipilih user 18 Okt 2026 daripada 3 lakaran widget, "ikut
   cadangan kau"):
     KIRI  = baris Products (atas, arahan user 18 Okt) + galeri Video style besar
             (bintang utama) dengan tag module di kepala galeri
     KANAN = panel tetapan yang sentiasa nampak (melekat bila skrol):
             Avatar (atas sekali, chip + menu seperti Workspace sebenar) → Scene →
             Model → ringkasan + Generate
     Telefon / skrin sempit: panel turun ke BAWAH galeri.

   Kekal daripada keputusan 15 Okt:
   • Module = TAG PERKATAAN; satu tag; klik tag sama sekali lagi = semua style.
   • Video style: belum klik tag → semua style; klik tag → style bertag itu.
   • Kad style: ▶ bilangan video dijana (bukan save), paling banyak dahulu,
     "Popular" (3 teratas SEMUA style) / "New" (bukan "0"). Tiada lencana tempoh.
   • Style tanpa muka (POV) → chip Avatar diganti makluman "No face in this
     style" (corak `avatarMati` Workspace sebenar).

   Asas rupa = Workspace v3.9: `s-panelbox`, `s-fgrid` / `s-fcard`, `s-pil`.
   ============================================================ */

import { useState, useRef, useEffect } from 'react';
import { Plus, X, Check, Zap, Play, FilePlus2, Pencil, Lock, ArrowUpDown, ListFilter, Image as ImageIcon, AlignLeft } from 'lucide-react';

import { Btn } from '../design/ui';
import { MediaStyle } from './GenerateV2Poster';
import AvatarChip, { ChipPilih } from './GenerateV2Avatar';
import { labelDurasi, formatGuna, petaScene, TEMPOH_BABAK, MAKS_BABAK, SLOT_AVATAR } from '../utils/generateV2';
import './GenerateV2Pilot.css';

const cx = (...bahagian) => bahagian.filter(Boolean).join(' ');
const HAD_ARAHAN = 500;   // arahan tambahan untuk AI (prototaip)
const IKON_FORMAT = { video: Play, image: ImageIcon, text: AlignLeft };
/* Pil produk yang dipapar sebelum "+N more" — SAMA seperti Classic
   (PromptComposerV39 `PIL_TERBUKA`), arahan user 26 Okt. */
const PIL_TERBUKA = 6;

/* Tekanan mendarat atas lapisan TERAPUNG (modal, menu chip, Product Library)?
   ⚠️ KEMBAR `atasLapisanTerapung` dalam PromptComposerV39.jsx — StudioShell
   sendiri `position:fixed` z-index 50, jadi yang membezakan lapisan terapung
   ialah z-index ≥ 100 (menu chip 210, modal 3000–9999). Ubah satu = ubah dua. */
const AMBANG_LAPISAN = 100;
function atasLapisanTerapung(el) {
    for (let n = el; n && n !== document.body; n = n.parentElement) {
        const g = window.getComputedStyle(n);
        if (g.position === 'fixed' && (parseInt(g.zIndex, 10) || 0) >= AMBANG_LAPISAN) return true;
    }
    return false;
}

export default function GenerateV2Komposer({
    produk, onTambah, onBuang,
    tags,
    matlamat, matlamatId, onMatlamat, kiraMatlamat,
    format, formatId, onFormat,
    susun, susunId, onSusun,
    styles, styleId, onStyle, popular,
    bilBabak, onBabak,
    model, modelId, onModel,
    avatar, avatarId, onAvatar, avatarSorok,
    sebabTakBoleh,
    /* ── Mod SEBENAR (Workspace /workspace, 23 Okt — GenerateV2Nyata.jsx). Semua pilihan;
       prototaip /workspace-v4 tidak menghantarnya, jadi rupanya tidak berubah. ── */
    onCipta, onTetapan, onCiptaModule, tambahan, kosongMesej,
    sceneBoleh, sceneTipMati, notaScene,
    peta, avatarSorokNota, onAvatarBaharu, onSuntingAvatar, slotAvatar = SLOT_AVATAR,
    jana = null,   // { label, boleh, tip, kuota, onClick, denyut } — Generate sebenar
    janaRef,       // ref butang Generate (popup Upgrade) — prop sendiri, bukan dalam `jana`
}) {
    const bilVideo = produk.length;
    const styleDipilih = styles.find((s) => s.id === styleId) || null;
    const [arahan, setArahan] = useState('');
    const namaModule = (s) => (s.tags || []).map((id) => (tags || []).find((t) => t.id === id)?.nama).filter(Boolean).join(' · ');
    /* Produk: prototaip { kunci, item:{name} } · sebenar { kunci, nama, img }. */
    const namaProduk = (p) => p.nama ?? p.item?.name ?? '';
    const adaPopular = popular instanceof Set;
    const [kembang, setKembang] = useState(false);

    /* Klik DI LUAR composer → nyahpilih module (arahan user 26 Okt, parity Classic).
       Zon dikecualikan = SELURUH composer (galeri + produk + panel kanan, termasuk
       butang Generate — kalau tidak, tekan Generate membatalkan module sebelum
       tekanan itu dikendalikan) + lapisan terapung (modal / menu).
       Fasa TANGKAP kerana sesetengah pengendali memanggil stopPropagation.
       Pengendali dalam ref supaya pendengar tidak dipasang semula setiap render. */
    const zonRef = useRef(null);
    const batalRef = useRef(null);
    useEffect(() => { batalRef.current = () => onStyle('', null); });
    useEffect(() => {
        if (!styleId) return undefined;
        const kena = (e) => {
            const el = e.target;
            if (!(el instanceof Element)) return;
            if (zonRef.current && zonRef.current.contains(el)) return;
            if (atasLapisanTerapung(el)) return;
            batalRef.current?.();
        };
        document.addEventListener('mousedown', kena, true);
        return () => document.removeEventListener('mousedown', kena, true);
    }, [styleId]);

    return (
        <div className="gv2-dua" ref={zonRef}>   {/* DUA kotak berasingan semula (arahan user 18 Okt) */}
            {/* ── KIRI: galeri Video style ── */}
            <section className="s-panelbox gv2-galeri" aria-label="Products and video style">
                {/* Products — baris paling atas kotak kiri (arahan user 18 Okt), rupa SAMA
                    seperti composer v3.9: butang Add Product + pil produk sebaris. */}
                <div className="gv2-produkbaris">
                    <button type="button" className="s-chip" onClick={onTambah} title={jana ? 'Add products from your library' : 'Add a sample product'}>
                        <Plus size={15} strokeWidth={2} /><span>Add Product</span>
                    </button>
                    {produk.length === 0 && <span style={{ fontSize: 12.5, color: 'var(--s-ink-3)' }}>No product attached yet</span>}
                    {(kembang ? produk : produk.slice(0, PIL_TERBUKA)).map((p) => (
                        <span key={p.kunci} className="s-pil" title={namaProduk(p)}>
                            {p.img
                                ? <img className="s-pil__th" src={p.img} alt="" style={{ objectFit: 'cover' }} />
                                : <span className="s-pil__th" style={{ background: 'var(--s-fill)' }} />}
                            <span className="s-pil__nm">{namaProduk(p)}</span>
                            <button type="button" className="s-pil__x" aria-label={`Remove ${namaProduk(p)}`} onClick={() => onBuang(p.kunci)}>
                                <X size={12} strokeWidth={2.2} />
                            </button>
                        </span>
                    ))}
                    {/* "Clear all" (arahan user 26 Okt): buang SEMUA produk daripada senarai
                        pilihan dengan satu klik, tanpa pengesahan (keputusan user). Hanya
                        mengosongkan pilihan composer — item My Products TIDAK dipadam.
                        Guna onBuang sedia ada untuk setiap produk (pengemas kini berfungsi
                        dalam App.jsx), jadi tiada prop/laluan baharu. */}
                    {/* "+N more / Show less" — salinan Classic (arahan user 26 Okt). */}
                    {produk.length > PIL_TERBUKA && (
                        <button type="button" className="s-pil s-pil--more" onClick={() => setKembang((v) => !v)}>
                            {kembang ? 'Show less' : `+${produk.length - PIL_TERBUKA} more`}
                        </button>
                    )}
                    {produk.length >= 2 && (
                        <button
                            type="button"
                            className="s-chip"
                            onClick={() => produk.forEach((p) => onBuang(p.kunci))}
                            title="Remove all products from this list"
                        >
                            <X size={14} strokeWidth={2} /><span>Clear all</span>
                        </button>
                    )}
                </div>

                {/* Matlamat = TAB TEKS gaya ClickUp (arahan user 22 Okt, ganti tab module): All · Sell ·
                    Grow · Earn + bilangan. Sort + Filter (format) di hujung kanan baris yang sama. */}
                <div className="gv2-vbar">
                    <div className="gv2-vtabs" role="tablist" aria-label="Goal">
                        {[{ id: '', nama: 'All' }, ...matlamat].map((t) => {
                            const on = t.id === matlamatId;
                            return (
                                <button
                                    key={t.id || 'semua'}
                                    type="button"
                                    role="tab"
                                    aria-selected={on}
                                    title={t.nota}
                                    className={cx('gv2-vtab', on && 'gv2-vtab--on')}
                                    onClick={() => onMatlamat(t.id)}
                                >
                                    {t.nama}<span>{kiraMatlamat[t.id] ?? 0}</span>
                                </button>
                            );
                        })}
                    </div>
                    <div className="gv2-vbar__alat">
                        {/* "+ New module" (admin) — pintu SAMA seperti galeri formula v3.9. */}
                        {onCiptaModule && (
                            <button type="button" className="s-chip" onClick={onCiptaModule}>
                                <Plus size={14} strokeWidth={2} /><span>New module</span>
                            </button>
                        )}
                        <ChipPilih
                            ikon={<ArrowUpDown size={14} strokeWidth={1.8} />}
                            label={susun.find((x) => x.id === susunId)?.nama || 'Sort'}
                            pilihan={susun}
                            nilai={susunId}
                            onPilih={onSusun}
                            lebar={160}
                            kanan
                        />
                        <ChipPilih
                            ikon={<ListFilter size={14} strokeWidth={1.8} />}
                            label={format.find((x) => x.id === formatId)?.nama || 'Filter'}
                            pilihan={[{ id: '', nama: 'All formats' }, ...format]}
                            nilai={formatId}
                            onPilih={onFormat}
                            lebar={160}
                            kanan
                        />
                    </div>
                </div>
                <div className="gv2-vinfo">
                    <span>{styles.filter((s) => !s.kosong && !s.cipta).length} {jana ? 'modules' : 'styles'}</span>
                    {formatId && (
                        <button type="button" className="gv2-vinfo__cip" onClick={() => onFormat('')} aria-label="Clear format filter">
                            {format.find((x) => x.id === formatId)?.nama}<X size={11} strokeWidth={2.2} />
                        </button>
                    )}
                </div>

                <div className={cx('s-fgrid', styleId && 's-fgrid--pilih')}>
                    {styles.map((s) => {
                        const on = s.id === styleId;
                        return (
                            <button
                                key={s.id}
                                type="button"
                                aria-pressed={on}
                                className={cx('s-fcard', on && 's-fcard--on', (s.kosong || s.cipta) && 's-fcard--new', s.terkunci && 's-fcard--kunci')}
                                /* "Create your own" = pintu ke halaman Formula (sebenar), bukan pilihan. */
                                onClick={() => (s.cipta ? onCipta?.() : onStyle(on ? '' : s.id, s))}
                                title={s.kunciTip || s.nama}
                            >
                                <span className="s-fcard__v">
                                    {s.cipta
                                        ? <span className="s-fcard__plus"><Plus size={19} strokeWidth={2} /></span>
                                        : s.kosong
                                        ? <span className="s-fcard__plus"><FilePlus2 size={18} strokeWidth={1.8} /></span>
                                        : (s.poster || s.video || !jana)
                                            ? <MediaStyle preset={s.poster || s.video ? { poster: s.poster, videoPratonton: s.video } : null} cerita={{ rentak: s.rentak }} gaya={{ id: s.ikon, nama: s.kecil }} />
                                            /* Module ciptaan admin tanpa media = petak kosong bernama (sama seperti galeri v3.9). */
                                            : <span style={{ color: 'var(--s-ink-3)', fontSize: 11 }}>{s.nama}</span>}
                                    {/* Pill jenis (HOLD / DEMO / ZOOM) atas media — arahan user 18 Okt. */}
                                    {s.pil && <span className="gv2-pilmedia">{s.pil}</span>}
                                    {s.baru
                                        ? <span className="gv2-lencana">New</span>
                                        : adaPopular && popular.has(s.id) && <span className="gv2-lencana gv2-lencana--popular">Popular</span>}
                                    {/* Hak pelanggan (UPGRADE / TRIAL n/5) — sama maklumat seperti galeri v3.9. */}
                                    {s.hak && <span className="gv2-guna">{s.hak}</span>}
                                    {/* Pensel tetapan module (admin) — pintu SAMA `bukaTetapanModule`. <span> kerana
                                        kad ini sendiri <button>. */}
                                    {onTetapan && !s.kosong && !s.cipta && (
                                        <span
                                            role="button" tabIndex={0} className="gv2-pensel" title="Module settings"
                                            onClick={(e) => { e.stopPropagation(); onTetapan(s.id); }}
                                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); onTetapan(s.id); } }}
                                        >
                                            <Pencil size={11} strokeWidth={2} />
                                        </span>
                                    )}
                                    {!s.baru && !s.kosong && !s.cipta && s.guna != null && (
                                        <span className="gv2-guna" title={`${Number(s.guna).toLocaleString('en-US')} videos made with this style`}>
                                            <Play size={9} strokeWidth={0} fill="currentColor" />{formatGuna(s.guna)}
                                        </span>
                                    )}
                                    {/* Tag format (Video / Image / Text) — penjuru kanan atas (arahan user 22 Okt). */}
                                    {IKON_FORMAT[s.format] && (() => {
                                        const Ikon = IKON_FORMAT[s.format];
                                        return <span className="gv2-format" title={s.format}><Ikon size={11} strokeWidth={2.2} /></span>;
                                    })()}
                                    {s.terkunci
                                        ? <span className="s-fcard__tick" style={{ background: 'var(--s-fill)', color: 'var(--s-ink-2)' }}><Lock size={11} strokeWidth={2.2} /></span>
                                        : on && <span className="s-fcard__tick"><Check size={12} strokeWidth={3} /></span>}
                                </span>
                                <span className="s-fcard__n">
                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.nama}</span>
                                    {s.tag && <span className="gv2-tagnama">{s.tag}</span>}
                                </span>
                                {/* Nama module jadi baris kecil (tab module dibuang 22 Okt); tiada module → keterangan.
                                    Mod sebenar menghantar `nota` siap (ayat admin / kamus). */}
                                <span className="s-fcard__d">{s.nota ?? (namaModule(s) || s.kecil)}</span>
                            </button>
                        );
                    })}
                </div>
                {styles.length === 0 && kosongMesej && <p className="gv2-kosong">{kosongMesej}</p>}

                {/* Tetapan ikut module (template GOYANG · sub-module · Suara Watak) — dihantar SIAP
                    dari App.jsx, logik tidak ditulis semula. Template GOYANG WAJIB sebelum Generate. */}
                {tambahan && <div className="gv2-tambahan">{tambahan}</div>}
            </section>

            {/* ── KANAN: panel tetapan (melekat) ── */}
            {/* SATU kotak (arahan user 18 Okt): kanan dipisah dengan garis menegak sahaja; isinya
                (tetapan + Generate) melekat semasa skrol supaya Generate sentiasa nampak. */}
            <aside className="gv2-panel" aria-label="Settings">
              {/* Kotak kanan gaya "composer" (rujukan PixVerse, versi B — dipilih user 18 Okt). HANYA pil
                  sedia ada (Avatar · Scene · Model · Your video · Generate) + kotak arahan tambahan.
                  Avatar / Scene / Model = DROPDOWN dalam satu bar; Generate = baris bawah sendiri.
                  PROTOTAIP: arahan tidak dihantar ke mana-mana. */}
              <div className="gv2-panel__isi gv2-cmp">
                <div className="gv2-cmp__kepala">
                    {/* Tajuk tetap "Prompt Input" (arahan user 18 Okt). */}
                    <b>Prompt Input</b>
                </div>

                {/* Avatar = BARIS TETAPAN di atas kotak taip (lakaran C4, dipilih user 23 Okt). */}
                <AvatarChip
                    avatar={avatar} avatarId={avatarId} onAvatar={onAvatar} sorok={avatarSorok} slot={slotAvatar} baris
                    notaSorok={avatarSorokNota} onBaharu={onAvatarBaharu} onSunting={onSuntingAvatar}
                />

                {styleDipilih?.kosong ? (
                    /* Blank Card (keputusan user 1 Nov): tiada AI menulis prompt, jadi kotak
                       "arahan untuk AI" tak berguna — ganti dengan nota pendek. Avatar · Model ·
                       Scene KEKAL di footer kerana kad tetap akan run Flow. */
                    <div className="gv2-cmp__kosongnota">
                        <FilePlus2 size={20} strokeWidth={1.7} />
                        <b>Blank card</b>
                        <span>You write the hook, image &amp; video prompts yourself in each card. No AI, no quota.</span>
                    </div>
                ) : (
                    <>
                        <textarea
                            className="gv2-cmp__teks"
                            value={arahan}
                            onChange={(e) => setArahan(e.target.value.slice(0, HAD_ARAHAN))}
                            maxLength={HAD_ARAHAN}
                            rows={5}
                            placeholder="Extra instructions for the AI (optional) — e.g. warm morning kitchen, mention free shipping"
                            aria-label="Extra instructions for the AI"
                        />
                        <p className="gv2-cmp__kira">{arahan.length}/{HAD_ARAHAN}</p>
                    </>
                )}

                {/* FOOTER: pill dropdown + Generate kekal di BAWAH kotak (arahan user 18 Okt). */}
                <div className="gv2-cmp__kaki">
                {/* Peta scene = TEMPAT TETAP (sentiasa satu baris) supaya susunan tidak melompat bila
                    kad style dipilih (aduan user 18 Okt). */}
                <p className="gv2-cmp__peta" title={styleDipilih ? styleDipilih.nama : undefined}>
                    {peta != null ? peta : styleDipilih
                        ? (styleDipilih.kosong
                            ? `Blank card · ${bilBabak} empty scene${bilBabak > 1 ? 's' : ''} — you write each one`
                            : petaScene(styleDipilih.rentak, bilBabak).map((x) => `S${x.no} ${x.teks}`).join('  ·  '))
                        : 'No style selected'}
                </p>
                {/* Model = DUA KOTAK TERBUKA dengan radio (lakaran C4, arahan user 23 Okt), bukan dropdown.
                    Blank Card (keputusan user 2 Nov): SOROK Veo/Omni — kad kosong pilih workflow (yang
                    bawa modelnya sendiri) kemudian di My Agent / Flow, bukan masa cipta. */}
                {!styleDipilih?.kosong && (
                <div className="gv2-model" role="radiogroup" aria-label="Video model">
                    {model.map((m) => {
                        const on = m.id === modelId;
                        return (
                            <button key={m.id} type="button" role="radio" aria-checked={on}
                                className={cx('gv2-model__kotak', on && 'gv2-model__kotak--on')} onClick={() => onModel(m.id)} title={m.nama}>
                                <span className="gv2-model__radio" />
                                <span><b>{m.pendek || m.nama}</b>{m.nota && <span>{m.nota}</span>}</span>
                            </button>
                        );
                    })}
                </div>
                )}

                {/* Scene — terbuka, di BAWAH pill Avatar + Model dalam Prompt Input (arahan user 18 Okt);
                    kotak kanan kekal 516px, kotak taip yang mengecil. */}
                <div className="gv2-scenebaris gv2-scenebaris--kaki" role="group" aria-label="Scene">
                    <span className="gv2-scenebaris__lbl">Scene <span>· {TEMPOH_BABAK}s each</span></span>
                    {Array.from({ length: MAKS_BABAK }, (_, i) => i + 1).map((n) => {
                        /* `sceneBoleh` (mod sebenar) = scene yang admin benarkan untuk module dipilih
                           (Module Settings, 24 Okt). Lain = malap + sebab bila dituding. */
                        const boleh = !sceneBoleh || sceneBoleh.includes(n);
                        return (
                            <button
                                key={n}
                                type="button"
                                aria-pressed={n === bilBabak}
                                disabled={!boleh}
                                title={boleh ? undefined : sceneTipMati}
                                className={cx('gv2-scenepil', n === bilBabak && 'gv2-scenepil--on')}
                                onClick={() => onBabak(n)}
                            >
                                {n} <span>· {labelDurasi(n)}</span>
                            </button>
                        );
                    })}
                </div>
                {/* Apa yang keluar dalam card — dibaca SEBELUM Generate (keputusan user 24 Okt). */}
                {notaScene && <p className="gv2-scenenota">{notaScene}</p>}

                {/* Generate — BARIS BAWAH sendiri (arahan user 18 Okt). PROTOTAIP: tidak membuat apa-apa. */}
                <div className="gv2-cmp__jana">
                    {jana ? (
                        /* Generate SEBENAR — label, syarat, tip, kuota dan pengendali datang SIAP dari App.jsx
                           (sama seperti composer v3.9). Pembalut ref: popup Upgrade mengukur butang ini. */
                        <span ref={janaRef} className={jana.denyut ? 'animate-pulse' : undefined} style={{ display: 'block', borderRadius: 10 }}>
                            <Btn
                                icon={<Zap size={15} strokeWidth={2} />}
                                disabled={!jana.boleh}
                                onClick={jana.onClick}
                                title={jana.tip || ''}
                                style={{ width: '100%', justifyContent: 'center' }}
                            >
                                {jana.label}
                                {jana.kuota && <span className="gv2-cmp__bil">{jana.kuota}</span>}
                            </Btn>
                        </span>
                    ) : (
                    <Btn
                        icon={<Zap size={15} strokeWidth={2} />}
                        disabled={!!sebabTakBoleh}
                        title={sebabTakBoleh || 'Prototype — nothing is generated'}
                        style={{ width: '100%', justifyContent: 'center' }}
                    >
                        {/* Sebab belum boleh = DALAM butang (tiada baris yang muncul/hilang). */}
                        {sebabTakBoleh || (styleDipilih?.kosong ? 'Create blank card' : 'Generate')}
                        {/* Blank Card: bilangan kad dicipta (satu per produk, atau 1 bila tiada produk). */}
                        {!sebabTakBoleh && <span className="gv2-cmp__bil">{styleDipilih?.kosong ? (produk.length || 1) : bilVideo}</span>}
                    </Btn>
                    )}
                </div>
                {/* Blank Card: beritahu kad mendarat di My Agent + boleh pindah (keputusan user 2 Nov). */}
                {styleDipilih?.kosong && <p className="gv2-cmp__landnota">New card opens in <b>My Agent</b> — move it to any tab later.</p>}
                </div>
              </div>
            </aside>
        </div>
    );
}
